import React from 'react'
import styled from 'styled-components'
import { IconsCreateTest } from '@edulastic/icons'
import { lightGreen10, navy900, themeColor } from '@edulastic/colors'
import BulkConvertDrawer from '../../../AssessmentCreate/components/CreateAITest/BulkConvertDrawer'

const HEADING = 'Convert a document or Google form into a test'
const BULK_CONVERT_SOURCE = 'testLibraryReadyTab'
const Icon = IconsCreateTest.IconContentConverter

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  text-align: center;
`

const EmptyStateHeading = styled.p`
  margin: 0 0 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${navy900};
`

/** Matches CreateTestBanner shortcut widget styling (white pill, icon + label). */
const ShortcutButton = styled.div`
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1.5px solid ${themeColor};
  cursor: pointer;
  height: 48px;
  border-radius: 4px;
  padding: 10px 20px;
  color: #2f4151;
  font-size: 14px;
  font-weight: 500;

  svg {
    margin-right: 10px;
  }

  &:hover {
    border-color: ${lightGreen10};
  }
`

const ReadyToReviewEmptyState = () => (
  <EmptyStateContainer>
    <EmptyStateHeading>{HEADING}</EmptyStateHeading>
    <BulkConvertDrawer source={BULK_CONVERT_SOURCE}>
      <ShortcutButton data-cy="readyTabConvertDocuments">
        <Icon />
        <span>Convert Documents</span>
      </ShortcutButton>
    </BulkConvertDrawer>
  </EmptyStateContainer>
)

export default ReadyToReviewEmptyState
